import React from 'react';

const MicrosoftOAuthButton = ({ className = "", disabled = false }) => {
  const handleMicrosoftLogin = () => {
    const microsoftClientId = process.env.REACT_APP_MICROSOFT_CLIENT_ID;
    const redirectUri = `http://localhost:5000/api/auth/microsoft/callback`; // Backend callback URL
    const tenantId = 'consumers'; // Try 'consumers' for personal accounts only
    
    // Microsoft OAuth URL with required parameters
    const microsoftOAuthUrl = `https://login.microsoftonline.com/${tenantId}/oauth2/v2.0/authorize?` +
      `client_id=${microsoftClientId}` +
      `&response_type=code` +
      `&redirect_uri=${encodeURIComponent(redirectUri)}` +
      `&response_mode=query` +
      `&scope=${encodeURIComponent('openid profile email User.Read')}` +
      `&state=${Math.random().toString(36).substring(7)}`;

    console.log('🚀 Microsoft OAuth URL:', microsoftOAuthUrl);

    // Redirect to Microsoft OAuth
    window.location.href = microsoftOAuthUrl;
  };

  return (
    <button
      type="button"
      onClick={handleMicrosoftLogin}
      disabled={disabled}
      className={`group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-gray-800 hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
    >
      <span className="absolute left-0 inset-y-0 flex items-center pl-3">
        <svg className="h-5 w-5 text-white" viewBox="0 0 24 24" fill="currentColor">
          <path d="M11.4 24H0V12.6h11.4V24zM24 24H12.6V12.6H24V24zM11.4 11.4H0V0h11.4v11.4zM24 11.4H12.6V0H24v11.4z"/>
        </svg>
      </span>
      Continue with Microsoft
    </button>
  );
};

export default MicrosoftOAuthButton;